import { Suspense, createContext, useContext, useState } from 'react';
import { IAppInitiator, IAppInitiatorContext } from 'types';
import { useBoot } from 'lib/useBoot';
import { ErrorPage } from 'requiro-ui-theme';
import { useTranslation } from 'react-i18next';
import { Progress } from 'components/Progress';

/**
 * context
 */
const Context = createContext<IAppInitiatorContext | null>(null);

/**
 * provider
 */
const AppInitiator = ({ children }: IAppInitiator) => {
  const { t } = useTranslation();
  const [token] = useState(null);
  const { boot, queryInfo } = useBoot();
  const { isError, isLoading } = queryInfo;

  /*
  TODO errore bootjson non trovato
  */
  if (isError) {
    return (
      <ErrorPage
        code={{ text: '404' }}
        title={{ text: t('titleErrorPage') }}
        button={{ text: t('textButtonErrorPage') }}
        problem={{
          text: t('textProblemErrorPage'),
          link: t('linkProblemErrorPage'),
        }}
      />
    );
  }

  if (isLoading) {
    return <Progress />;
  }

  const contextValue = {
    boot,
    token,
  };

  return (
    <Context.Provider value={contextValue}>
      <Suspense fallback={<Progress />}>{children}</Suspense>
    </Context.Provider>
  );
};

/**
 * custom hook
 */
export function useAppInitiator() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error('AppInitiator Context cannot be undefined!');
  return ctx;
}

export default AppInitiator;
